import React from 'react';
import { Package2, Rocket } from 'lucide-react';

import { SplitButton } from '@/Modules/Core/Components/shadcn/split-button';

const ACCUMULATIVE_OPTION = {
  id: 'accumulative',
  label: 'Accumulative Rollout',
  icon: Package2,
};

const ProjectActions = ({
  project,
  onCreateRollout,
  onCreateAccumulative,
  createLabel = 'Create Rollout',
  canCreateRollout = true,
}) => (
  <div onClick={(event) => event.stopPropagation()}>
    {canCreateRollout ? (
      <SplitButton
        primaryAction={
          <>
            <Rocket className="mr-2 h-3.5 w-3.5" />
            <span className="truncate">{createLabel}</span>
          </>
        }
        menuOptions={[ACCUMULATIVE_OPTION]}
        onPrimaryClick={() => onCreateRollout(project)}
        onSelect={(option) => {
          if (option.id === ACCUMULATIVE_OPTION.id) {
            onCreateAccumulative(project);
          }
        }}
        className="w-full"
      />
    ) : null}
  </div>
);

export default ProjectActions;
